import { BillTypes, CurrencySymbol, ShopType } from 'models';
import { formatMoney, moneyFormat } from 'utils';
import * as svg from '../../../constants/ui/svg';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'hooks';
export interface HeaderProps {
  billData: BillTypes;
  show: () => void;
  onBill: (data: BillTypes) => void;
}

export function Header(props: HeaderProps) {
  const { billData, show, onBill } = props;
  const router = useLocation();
  const { t } = useTranslation();
  const searchParams = new URLSearchParams(router.search);
  const shop_id = router.search?.split('=')[1].split('&')[0];
  const table_id = router.search?.split('=')[2];
  const bill_id = Number(searchParams.get('bill_id'));
  const selectedShop: any = useAppSelector((state) => state.shop.shopInfo);
  const urlShowMenu = `/bills-table-detail?shop_id=${shop_id}&table_id=${table_id}${
    bill_id ? `&bill_id=${bill_id}` : ''
  }`;
  return (
    <>
      <div className="bg-primary flex relative flex-col justify-center p-5 h-40">
        <Link to={urlShowMenu} className="absolute top-3 left-4">
          {svg.arrowLeftIcon}
        </Link>
        {/* <div className=" flex justify-end">
          <button
            onClick={() => {
              show();
              onBill(billData);
            }}
            className="border border-white border-solid px-[15px] py-[4px] text-white"
          >
            {t('BILL_DETAIL')}
          </button>
        </div> */}
        <div className="flex flex-col text-white justify-center items-center space-y-2">
          <span>{t('TOTAL')}</span>
          <span className="text font-bold text-[36px]">
            {moneyFormat(billData?.total_payment || 0, selectedShop?.currency || '¥')}

            {/* {formatMoney(billData?.total_payment || 0)} */}
          </span>
        </div>
      </div>
    </>
  );
}
